// extracted by mini-css-extract-plugin
export var closeButton = "_2x-3";
export var header = "_2x-0";
export var link = "_2x-1";
export var retryButton = "_2x-2";